import { pick, without } from 'underscore';
import { formatDateToAPIFormat, parseDateFromAPIFormat } from './utils';

const whitelistedSchemaPropertyKeysForModel = [
  'Id', 'Status', 'Medium', 'AdDistribution', 'SearchBid', 'StartDate', 'EndDate',
];

export const viewModelToModelForAdGroupBudget = (adGroupViewModel, campaignId, i18n) => {
  const data = {
    ...pick(adGroupViewModel, without(whitelistedSchemaPropertyKeysForModel, 'Status')),
    Campaign: {
      Id: campaignId,
    },
  };
  data.StartDate = formatDateToAPIFormat(i18n, data.StartDate);
  data.EndDate = data.EndDate ? formatDateToAPIFormat(i18n, data.EndDate) : '1/1/3000';

  return data;
};

export const bulkModelToViewModelForAdGroupBudget = ({
  adGroupModel,
  i18n,
}) => {
  const data = {
    ...pick(adGroupModel, whitelistedSchemaPropertyKeysForModel),
  };
  data.StartDate = parseDateFromAPIFormat(i18n, adGroupModel.StartDate);
  data.EndDate = parseDateFromAPIFormat(i18n, adGroupModel.EndDate);

  return data;
};

export const modelToViewModelForAdGroupBudget = (adGroupModel, i18n) => {
  const viewModel = {
    ...pick(adGroupModel, whitelistedSchemaPropertyKeysForModel),
  };

  viewModel.StartDate = parseDateFromAPIFormat(i18n, adGroupModel.StartDate);
  viewModel.EndDate = parseDateFromAPIFormat(i18n, adGroupModel.EndDate);

  return viewModel;
};
